import React from "react";
import { Controller } from "react-hook-form";
import Input from "./Input";

const EmailInput = ({
  name,
  control,
  displayName,
  required,
  placeholder,
  errors,
  disabled,
  value,
  onChange,
  onBlur,
  className,
  id,
}) => {
  // Use react-hook-form when control is provided; otherwise fallback to plain Input
  if (control && name) {
    return (
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${displayName} is required` : null,
          pattern: {
            value: /^\S+@\S+\.\S+$/,
            message: "Please enter a valid email",
          },
        }}
        render={({ field: { ref, ...field } }) => (
          <Input
            {...field}
            type="email"
            placeholder={placeholder}
            invalid={!!errors}
            disabled={disabled}
            className={className}
            id={id}
          />
        )}
      />
    );
  }

  return (
    <Input
      id={id}
      type="email"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      invalid={!!errors}
      disabled={disabled}
      className={className}
    />
  );
};

export default EmailInput;
